<div class="flex flex-col w-full h-full">
  <!-- Título do gráfico -->
  <h3 class="text-lg font-semibold mb-4 text-center">{{ title }}</h3>
  
  <!-- Container responsivo que alterna entre barras verticais e lista horizontal -->
  <div class="flex-1 flex flex-col">
    <!-- Layout para desktop (barras verticais) -->
    <div class="hidden md:flex flex-col relative pt-8 h-[calc(100%-60px)]">
      <!-- Grid de fundo -->
      <div class="absolute inset-0 w-full h-full flex flex-col justify-between pt-8 pb-16">
        <ng-container *ngFor="let value of gridValues; let i = index">
          <div class="relative">
            <div class="h-px w-full bg-gray-300"></div>
            <span class="absolute left-0 top-0 transform -translate-y-1/2 text-xs text-gray-600">{{ formatGridValue(value) }}</span>
          </div>
        </ng-container>
      </div>
      
      <!-- Container das barras -->
      <div class="flex-1 flex items-end justify-around h-full px-4">
        <ng-container *ngFor="let item of data; let i = index">
          <div class="flex flex-col items-center justify-end h-full relative flex-1 max-w-[60px]">
            <!-- Valor acima da barra -->
            <div class="text-xs font-bold absolute -top-6 left-1/2 -translate-x-1/2 z-10 text-gray-700 whitespace-nowrap">
              {{ formatValue(item.value) }}
            </div>
            
            <!-- Barra -->
            <div class="w-full flex justify-center mb-2 h-full relative">
              <div 
                class="w-8 rounded-t-md transition-all duration-500 ease-in-out absolute bottom-0 shadow-lg" 
                [ngClass]="getColorClass(i)"
                [ngStyle]="{ 'height': getBarHeight(item.value) }"
              ></div>
            </div>
            
            <!-- Label -->
            <div class="text-xs text-center w-full text-gray-600 mt-1 leading-tight" [title]="item.label">
              {{ item.label.length > 8 ? (item.label | slice:0:8) + '...' : item.label }}
            </div>
          </div>
        </ng-container>
      </div>
    </div>

    <!-- Layout para mobile (barras horizontais) -->
    <div class="md:hidden flex flex-col gap-3 h-full overflow-y-auto">
      <ng-container *ngFor="let item of data; let i = index; trackBy: trackByIndex">
        <div class="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
          <div class="flex items-center flex-1 min-w-0">
            <div [ngClass]="getColorClass(i)" class="w-4 h-4 mr-3 rounded-sm flex-shrink-0"></div>
            <div class="flex-1 min-w-0">
              <div class="text-sm font-medium text-gray-900 truncate" [title]="item.label">
                {{ item.label }}
              </div>
              <div class="text-xs text-gray-500">
                Origem de cliente
              </div>
            </div>
          </div>
          <div class="ml-3 flex-shrink-0 text-right">
            <div class="text-lg font-bold text-gray-900">{{ formatValue(item.value) }}</div>
            <div class="text-xs text-gray-500">clientes</div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div> 